import { render } from "./ExpenseReceiptDetailTabsPanel.vue?vue&type=template&id=79320912"
import script from "./ExpenseReceiptDetailTabsPanel.vue?vue&type=script&lang=js"
export * from "./ExpenseReceiptDetailTabsPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__